<form #ngF="ngForm" class="k-form-inline" novalidate [formGroup]="form">

  <div class="offset-3 col-md-5 no-padding text-right">
    <button type="button" class="btn btn-primary" style="margin: 10px 0;" id="open-file-selector"
      name="open-file-selector" (click)="openFile()">Open File Selector</button>
  </div>

  <div class="k-form-field">
    <label for="description" class="form-label col-3">Content</label>
    <div class="col-8">
      <!-- AutoFocused! <input appAutoFocus> -->
      <textarea type="text" style="width: 100%; height: 600px;" rows="10" cols="30" id="fileContent" readonly
        formControlName="fileContent" class="form-control">
        </textarea>
    </div>
  </div>

  <div class="d-grid d-md-flex justify-content-md-end">
    <!-- <button type="button" class="btn btn-primary me-md-2" type="submit" [disabled]="form.invalid"> Save</button> -->
    <button type="button" class="btn btn-secondary" (click)="closeWindow()"> Cancel</button>
  </div>

</form>
